import React, { Component } from "react";
import { 
    Button,
    Intent,
    Card, 
    FormGroup,
    InputGroup,
    Checkbox,
    Menu,
    MenuItem,
    Tag,
    Tooltip,
    Classes,
    Position,
    OverlayToaster,
    Callout } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { Trans } from "react-i18next";
import {
  DateInput3,
  TimePrecision
} from "@blueprintjs/datetime2";
import { EacAuthenticatedGetFetch, EacAuthenticatedPutFetch, EacAuthenticatedDeleteFetch } from "../../utils/ExternalAccessControlAuthenticatedFetch";

import i18next from 'i18next';
import { TableCustom } from "../Structure/navbar/blueprintTableincludes";
import TimePeriode from "./TimePeriode";
import SiteParkListSelect from '../Structure/SiteSelector';
import EquipmentListSelect, { deviceLookup } from "../Structure/EquipmentSelector";
import { parkLookupDiscount } from "../Bonification/lookup";

import { mefMontantStr, mefPlate } from "../../utils/mef";



const URL = window.config.backend.eac_route + '/immat';

const GratuityParksMode = {
  ExclusiveByDay: "ExclusiveByDay",
  AllowNbPassage: "AllowNbPassage",
  Unknown: "Unknown"
}

export default class GratuityParksPage extends Component {
    constructor() {
        super();
        this.state = {
          mode: "ExclusiveByDay",
          tariffOffset: 0,
          gratuity: 30,
          nbRetentionDaysForImmat: 3,
          threshold: 3,
          listParks: [],
          gratuityNbPassageMode:0,
          countingResetAfterPayment: false,
          countingByParc: false,

          filter_immat: '',
          filter_equip: [],
          filter_parc: [],
          filter_startdate: undefined,
          filter_enddate: undefined,

          refresh: Date.now(),

          url: URL,

          timePeriodDataList:[],

          deviceLookup: [],
          parkLookup:[],
          openConfigPanel: false
        };        
    }

    toasterRef = React.createRef();
    showToaster(msg, intent, icon) {
      this.toasterRef.current?.show({
        message: msg,
        intent: intent,
        icon: icon
      });
    }

    componentDidMount() {
        EacAuthenticatedGetFetch('/gratuityparks/config', 
          async (data)=>{
            const retState = {mode: "ExclusiveByDay", tariffOffset: 0, gratuity: 30, 
                              threshold: 3, timePeriodDataList:[], listParks:[], 
                              gratuityNbPassageMode:0, countingByParc: false, countingResetAfterPayment: false};
            if(data.mode)
                retState.mode = data.mode;
            if(data.tariffOffset !== undefined)
                retState.tariffOffset = data.tariffOffset;
            if(data.gratuity !== undefined)
                retState.gratuity = data.gratuity;
            if(data.nbRetentionDaysForImmat !== undefined)
                retState.nbRetentionDaysForImmat = data.nbRetentionDaysForImmat;
            if(data.threshold !== undefined)
                retState.threshold = data.threshold;
            if(data.countingResetAfterPayment !== undefined)
              retState.countingResetAfterPayment = data.countingResetAfterPayment;
            if(data.countingByParc !== undefined)
              retState.countingByParc = data.countingByParc;
            if(data.modeAllowNbPassage !== undefined)
                retState.gratuityNbPassageMode = data.modeAllowNbPassage;
            if(data.timePeriod !== undefined){
                retState.timePeriodDataList = data.timePeriod;
                retState.timePeriodDataList.forEach(val=>{
                  val.date.forEach(d=>{
                    d.startDay = Number(d.startDay);
                    d.endDay = Number(d.endDay);
                    d.startHour = Number(d.startHour);
                    d.startMinutes = Number(d.startMinutes);
                    d.endHour = Number(d.endHour);
                    d.endMinutes = Number(d.endMinutes);
                  });
                });
            }
            if(data.listParks !== undefined)
                retState.listParks = data.listParks;
            
            retState.deviceLookup = await deviceLookup();
            retState.parkLookup = await parkLookupDiscount();
            this.setState(retState);
        }, null, undefined, async (error)=>{
          this.showToaster('Configuration cannot be recovered', "danger", "error");
        }, false);       
    }
    disableSaveButton(){
        return !(this.state.mode.length > 0 
            &&  this.state.tariffOffset >= 0
            &&  this.state.gratuity >= 0);
    }
    saveConfig() {
      const payload = {
        mode: this.state.mode,
        tariffOffset: this.state.tariffOffset,
        gratuity: this.state.gratuity,
        nbRetentionDaysForImmat: this.state.nbRetentionDaysForImmat,
        threshold: this.state.threshold,
        timePeriod: this.state.timePeriodDataList,
        listParks: this.state.listParks.map(p=>{return {id:p.id, name: p.name};}),
        modeAllowNbPassage : this.state.gratuityNbPassageMode,
        countingResetAfterPayment: this.state.countingResetAfterPayment,
        countingByParc: this.state.countingByParc
      }
      EacAuthenticatedPutFetch('/gratuityparks/config', payload, (data)=>{
        this.showToaster('Configuration saved', 'success', 'tick');
      },(error)=>{        
        this.showToaster('Configuration not saved', "danger", "error");
      });
    }
    
    deleteImat(pk){
      EacAuthenticatedDeleteFetch('/immat', {pk}, (data)=>{        
        this.setState({
          refresh: Date.now()
        });
        this.showToaster('Licence plate removed', 'success', 'tick');
      },(error)=>{        
        this.showToaster('Licence plate not removed', "danger", "error");
      });
    }

    clearFilter(){
      this.setState({
          filter_immat: '',
          filter_equip: [],
          filter_parc: [],
          filter_startdate: undefined,
          filter_enddate: undefined,
          url: URL,
          refresh: Date.now()});
    }
    updateFilter(){
      
      let param = '';
      if(this.state.filter_immat !== ''){
        param += `&immat=${this.state.filter_immat}`;
      }
      if(this.state.filter_equip.length > 0){
        if(param.length !== 0) param += '&';
        param += `numEqui=${this.state.filter_equip[0].id}`;        
      }
      if(this.state.filter_parc.length > 0){
        if(param.length !== 0) param += '&';
        param += `parc=${this.state.filter_parc[0].id}`;  
        
      }
      if(this.state.filter_startdate !== undefined){
        if(param.length !== 0) param += '&';
        param += `dateStart=${new Date(this.state.filter_startdate).getTime() / 1000}`;  
        
      }
      if(this.state.filter_enddate !== undefined){
        if(param.length !== 0) param += '&';
        param += `dateEnd=${new Date(this.state.filter_enddate).getTime() / 1000}`;          
      }
      this.setState({url: URL + (param.length>0? '?' : '') + param });
    }
    getImmatUrl(){
      return this.state.url
    }

    updateDataTimePeriod(val){
      this.setState({timePeriodDataList: val});
    }
    getParkName(id){
      const park = this.state.parkLookup.filter(val=>{
        return val.id === id;
      });
      return park ? park[0]?.name : id;
    }
    getDeviceName(id){
      const device = Object.keys(this.state.deviceLookup).filter(val=>{
        return Number(val) === id;
      });
      return device.length > 0 ? this.state.deviceLookup[device[0]] : id;
    }
    toggleConfigPanel(){
      this.setState({openConfigPanel: !this.state.openConfigPanel});
    }

    render() {
        return (
          <div>
            {localStorage.getItem('perm_admin') === "true" &&
              <Callout  title={<>
                <Trans>Configuration</Trans> 
                {" "}
                <Tooltip
                  content={this.state.openConfigPanel?<Trans>hide</Trans>: <Trans>show</Trans>}
                >
                  <Button
                    icon={this.state.openConfigPanel?"collapse-all": "expand-all"}
                    intent={Intent.NONE}
                    type="submit"
                    onClick={() => { this.toggleConfigPanel()}}
                    />
                </Tooltip>
                </>} >
                 <div className="flexbox-right">
                  
                </div>
                {/* configuration */}
                {this.state.openConfigPanel &&
                  <>
                    <Card>
                      <Card>
                          <form>
                            <FormGroup label={i18next.t("Mode") + i18next.t(":") } labelFor="gp-bo-url-input">
                              <Select
                                items={[GratuityParksMode.ExclusiveByDay, GratuityParksMode.AllowNbPassage, GratuityParksMode.Unknown]}
                                itemRenderer={(item, { selecttt, modifiers }) => {
                                  return <MenuItem
                                    label={item}
                                    text={item}
                                    onClick={() => {
                                      this.setState({ mode: item});
                                    }}
                                    itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                                      const renderedItems = items.map(renderItem).filter(item => (item != null && item === this.state.mode));
                                      return (
                                        <Menu ulRef={itemsParentRef}>
                                          <MenuItem
                                            disabled={true}
                                          />
                                          {renderedItems}
                                        </Menu>
                                      );
                                    }}
                                  />
                                }}
                              >
                                <Button text={this.state.mode === undefined ? "select a mode to set": this.state.mode} rightIcon="double-caret-vertical" />
                              </Select>
                            </FormGroup>


                            <FormGroup label={i18next.t("tariff Offset") + i18next.t(":") } labelFor="gp-tariffoffset-input">
                              <InputGroup
                                id="gp-tariffoffset-input"
                                type="number"
                                onChange={(ti) => { this.setState({ tariffOffset: parseInt(ti.target.value) }); }}
                                value={this.state.tariffOffset}
                                intent="normal"
                              />
                            </FormGroup>
                            <FormGroup label={i18next.t('Free time in minutes') + i18next.t(':')} labelFor="gp-gratuity-input">
                              <InputGroup
                                id="gp-gratuity-input"
                                type="number"
                                onChange={(ti) => { this.setState({ gratuity: parseInt(ti.target.value) }); }}
                                value={this.state.gratuity}
                                intent="normal"
                              />
                            </FormGroup>
                      
                            <FormGroup label={<Trans>number of retention days</Trans>} labelFor="gp-retention-input">
                              <InputGroup
                                id="gp-retention-input"
                                type="number"
                                onChange={(ti) => { this.setState({ nbRetentionDaysForImmat: parseInt(ti.target.value) }); }}
                                value={this.state.nbRetentionDaysForImmat}
                                intent="normal"
                              />
                            </FormGroup>

                            <FormGroup label={<Trans>list of parks to include</Trans>} labelFor="input_site">
                              <SiteParkListSelect id="input_parks"
                                label={<Trans>add a park</Trans>}
                                onSelect={(siteId, site) => this.setState({ listParks: [...this.state.listParks, site] })}
                                selected={this.state.listParks}
                              />
                              <div className="flexbox-left">
                                {
                                  this.state.listParks?.length > 0 &&
                                  this.state.listParks?.map((site, index) => (
                                    <Tag
                                      key={index}
                                      onRemove={() => {
                                        const tab = [...this.state.listParks];
                                        tab.splice(index, 1);
                                        this.setState({ listParks: tab })
                                      }}
                                    >
                                      {site.name}
                                    </Tag>
                                  ))
                                }
                              </div>
                            </FormGroup>

                          { this.state.mode === GratuityParksMode.AllowNbPassage &&
                          <>
                            <FormGroup label={<Trans>Nb entry before tax</Trans>} labelFor="gp-threshold-input">
                              <InputGroup
                                id="gp-threshold-input"
                                type="number"
                                onChange={(ti) => { this.setState({ threshold: parseInt(ti.target.value) }); }}
                                value={this.state.threshold}
                                intent="normal"
                              />
                            </FormGroup>
                            <FormGroup label={<Trans>Gratuity mode</Trans>} labelFor="gp-gratuityNbPassageMode-input">
                              <InputGroup
                                id="gp-gratuityNbPassageMode-input"
                                type="number"
                                onChange={(ti) => { this.setState({ gratuityNbPassageMode: parseInt(ti.target.value) }); }}
                                value={this.state.gratuityNbPassageMode}
                                intent="normal"
                              />
                            </FormGroup>
                            <div className="box">
                              <label><Trans>Gratuity mode 0 info</Trans></label> {" - "}
                              <label><Trans>Gratuity mode 1 info</Trans></label>
                            </div>
                            { this.state.gratuityNbPassageMode === 1 && <>  
                              <div className="box">
                                <FormGroup labelFor="gp-gratuityMode0-countingbyparc-input">
                                  <Checkbox 
                                    checked={this.state.countingByParc} 
                                    onChange={(st)=>{this.setState({countingByParc: st.target.checked})}}
                                    id="gp-gratuityMode0-countingbyparc-input"
                                    >
                                      {i18next.t('counting performed by device parc requesting')}
                                  </Checkbox>
                                </FormGroup>
                                <FormGroup labelFor="gp-gratuityMode0-countingreset-input">
                                  <Checkbox 
                                  checked={this.state.countingResetAfterPayment} 
                                  onChange={(st)=>{this.setState({countingResetAfterPayment: st.target.checked})}}
                                  id="gp-gratuityMode0-countingbyparc-input"
                                  >
                                      <Trans>counting resting by payment</Trans>
                                  </Checkbox>
                                </FormGroup>
                              </div>
                            </> }
                          </>
                          }  
                          </form>

                        </Card>

                        <Card>
                          <TimePeriode 
                          data={this.state.timePeriodDataList} 
                          updateTimePeriodCB={(val)=>{
                              this.updateDataTimePeriod(val);
                          }}
                          deleteItemCB={(index)=>{
                            const item = [...this.state.timePeriodDataList];
                            item.splice(index, 1);
                            this.setState({timePeriodDataList: item});
                          }}
                          ></TimePeriode>
                        </Card>
                    </Card>                  
                    <div className="flexbox-right">
                      <Button
                          text={<Trans>edit</Trans>}
                          icon="send-to"
                          intent={Intent.WARNING}
                          type="submit"
                          disabled={this.disableSaveButton()}
                          onClick={() => { this.saveConfig()}}
                          />
                    </div>
                  </>
                }
              </Callout>
            }
            {/* Filter to immat list */}
            <Callout  title={<Trans>View registered license plates</Trans>}>
            <Card>
                  <form 
                  key={this.state.refresh}>
                    <FormGroup label={i18next.t("Licence plate") + i18next.t(":")} labelFor="gp-tariffoffset-input">
                      <InputGroup
                        id="filter-immat-input"
                        onChange={(ti) => { this.setState({ filter_immat: ti.target.value }); }}
                        value={this.state.filter_immat}
                        intent="normal"
                      />
                    </FormGroup>
                    <FormGroup label={i18next.t("exit terminal") + i18next.t(":")} labelFor="filter-exitequip-input">
                      {/* <InputGroup
                        id="filter-exitequip-input"
                        type="number"
                        onChange={(ti) => { this.setState({ filter_equip: parseInt(ti.target.value) }); }}
                        value={this.state.filter_equip}
                        intent="normal"
                      /> */}
                      <EquipmentListSelect
                        label={i18next.t("add device")}
                        valueSelected={this.state.filter_equip}
                        onSelect={(deviceId, device) =>
                          this.setState({
                            filter_equip: [device],
                          })
                        }
                      />

                      <div className="flexbox-left">
                        {this.state.filter_equip.map((device, index) => (
                          <Tag
                            key={index}
                            onRemove={() =>
                              this.setState({
                                filter_equip: this.state.filter_equip.filter(
                                  (i) => i !== device
                                ),
                              })
                            }
                          >
                            {device.name}
                          </Tag>
                        ))}
                      </div>                      
                    </FormGroup>
                    <FormGroup label={i18next.t('park name') + i18next.t(':')} labelFor="input_parkss">
                      <SiteParkListSelect id="input_parkss"
                        label={<Trans>add a park</Trans>}
                        onSelect={(siteId, site) => this.setState({ filter_parc: [site] })}
                        selected={this.state.filter_parc}
                      />
                      <div className="flexbox-left">
                        {
                          this.state.filter_parc?.length > 0 &&
                          this.state.filter_parc?.map((site, index) => (
                            <Tag
                              key={index}
                              onRemove={() => {
                                const tab = [...this.state.filter_parc];
                                tab.splice(index, 1);
                                this.setState({ filter_parc: tab })
                              }}
                            >
                              {site.name}
                            </Tag>
                          ))
                        }
                      </div>
                    </FormGroup> 
                    <FormGroup label={i18next.t("entry date") + i18next.t(":")} labelFor="filter-startdate-input">
                      <DateInput3
                        id="filter-startdate-input"
                        timePrecision={TimePrecision.MINUTE} formatDate={date => date.toLocaleString(i18next.language)} 
                        highlightCurrentDay={true}
                        onChange={(selectedDate) => this.setState({ filter_startdate: selectedDate })}
                        value={this.state.filter_startdate ? this.state.filter_startdate: undefined}
                        locale={i18next.language}
                      />
                    </FormGroup>  
                    <FormGroup label={i18next.t("exit date") + i18next.t(":")} labelFor="filter-enddate-input">
                      <DateInput3
                        id="filter-enddate-input"
                        timePrecision={TimePrecision.MINUTE} formatDate={date => date.toLocaleString(i18next.language)} 
                        highlightCurrentDay={true}
                        onChange={(selectedDate) => this.setState({ filter_enddate: selectedDate })}
                        value={this.state.filter_enddate ? this.state.filter_enddate : undefined}
                        locale={i18next.language}
                      />
                    </FormGroup> 
                  </form>
                  <div className="flexbox-right">
                    <Button
                        text={<Trans>clear</Trans>}
                        icon="clean"
                        intent={Intent.WARNING}
                        type="submit"
                        disabled={false}
                        onClick={() => { this.clearFilter()}}
                        />
                    <Button
                        text={<Trans>edit</Trans>}
                        icon="send-to"
                        intent={Intent.WARNING}
                        type="submit"
                        disabled={false}
                        onClick={() => { this.updateFilter()}}
                        />
                  </div>
              </Card>
              {/* List des immats */}
              <Card>
                <TableCustom
                  key={this.state.refresh}
                  paging={true}
                  url={this.getImmatUrl()}
                  orderBy="dateOut"
                  columns={[
                    {
                      title: <Trans>Licence plate</Trans>,
                      field: "immat",
                      sortable: true,
                      render: raw => {return <Tag icon="blank" className="licenseplate-little"> {mefPlate(raw.immat)} </Tag>}
                    },
                    {
                      title: <Trans>entry date</Trans>,
                      field: "dateIn",
                      sortable: true,
                      render: raw => { return new Date(raw.dateIn).toLocaleString(i18next.language) }
                    },
                    {
                      title: <Trans>exit date</Trans>,
                      field: "dateOut",
                      sortable: true,
                      render: raw => { return new Date(raw.dateOut).toLocaleString(i18next.language) }
                    },
                    {
                      title: <Trans>entry terminal</Trans>,
                      field: "equipInId",
                      sortable: true,
                      render: raw => {return <Tag> {this.getDeviceName(raw.equipInId)} </Tag>}
                    },
                    {
                      title: <Trans>exit terminal</Trans>,
                      field: "equipId",
                      sortable: true,
                      render: raw => {return <Tag> {this.getDeviceName(raw.equipId)} </Tag>}
                    },
                    {
                      title: <Trans>paid amount</Trans>,
                      field: "payed",
                      sortable: true,
                      render: raw => {return <Tag> {mefMontantStr(raw.payed)} </Tag>}
                    },
                    {
                      title: <Trans>tariff Offset</Trans>,
                      field: "offset",
                      sortable: true,
                      render: raw => {return <Tag> {raw.offset} </Tag>}
                    },
                    {
                      title: <Trans>Free time in minutes</Trans>,
                      field: "gratuity",
                      sortable: true,
                      render: raw => {return <Tag> {raw.gratuityUsed} </Tag>}
                    },
                    {
                      title: <Trans>park</Trans>,
                      field: "parcId",
                      sortable: true,
                      render: raw => {return <Tag> {this.getParkName(raw.parcId)} </Tag>}
                    },
                    {
                      title: <Trans>action</Trans>,
                      field: "actionId",
                      sortable: true,
                      render: raw => {
                        if(localStorage.getItem('perm_admin') === "true")
                          return (<Button
                            text={<Trans>delete</Trans>}
                            icon="cross"
                            intent={Intent.DANGER}
                            type="submit"
                            disabled={false}
                            onClick={() => { this.deleteImat(raw.pk)}}
                            />);
                        else
                          return (<></>);
                      }
                    }
                  ]}
                />
              </Card>
              <OverlayToaster className={Classes.TOAST_CONTAINER} usePortal={true} ref={this.toasterRef} position={Position.RIGHT_BOTTOM} />
            </Callout>
          </div>
        );
    }
}
